import * as React from 'react';
import clx from 'classnames';
import './ResponsiveHide.scss';

export interface ResponsiveHideProps {
  children: React.ReactNode;
  className?: string;
  inline?: boolean;
  mobileOnly?: boolean;
  desktopOnly?: boolean;
  breakPoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'; // | 'xxl';
  style?: React.CSSProperties;
}

/**
 * Elemento per permettere la visualizzazione in base al dispositivo
 */
export function ResponsiveHide(props: ResponsiveHideProps) {
  const breakPoint = props.breakPoint ?? 'md';
  return (
    <div
      style={props.style}
      className={clx('responsive-hide', props.className, breakPoint, {
        'display-inline': props.inline,
        'mobile-only': props.mobileOnly,
        'desktop-only': !props.mobileOnly && props.desktopOnly
      })}
    >
      {props.children}
    </div>
  );
}
